export default __webpack_public_path__ + "static/media/ico-predefinido-sel.3f0c376d.svg";